import React from "react";
import Page from "components/Page/Page";
import CalendarView from "./CalendarView";

const Calendar = () => {
  return (
    <Page
      title="Calendar"
      subTitle="Drag a range to add an event. Click an event to remove it."
    >
      <CalendarView />
    </Page>
  );
};

export default Calendar;
